import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import WhyPDFServicesAPI from './pdf-services/why-pdf-services-api.md';
import KeyFeaturesCodeBlock from './pdf-services/key-features-code-block.md';
import AWSMSCarousel from './pdf-services/aws-ms-carousel.md';
import StartModifyingPDF from './pdf-services/start-modifying-pdf.md';
import UseCasesResourceCard from './pdf-services/use-cases-resource-cards.md';
import DocumentServicesProductCards from './pdf-services/document-services-product-cards.md';
import AdobePDFExtractAPI from './pdf-services/adobe-pdf-extract-api.md';
import { APIPixelRetargeting } from '../../components/retargetting';
import { NewsLetterBlade } from '../../components/news-letter-blade';
import EsealApiAnnouncement from './e-seal-api-announcement.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const WrapperComponent = makeShortcode("WrapperComponent");
const TextBlock = makeShortcode("TextBlock");
const DCSummaryBlock = makeShortcode("DCSummaryBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Hero slots="heading, text, assetsImg, buttons" customLayout variant="fullwidth" className="herobgImage Hero-Banner" mdxType="Hero" />
    <h1 {...{
      "id": "adobe-pdf-services-api"
    }}>{`Adobe PDF Services API`}</h1>
    <p>{`Create, convert, transform, OCR PDFs and more.`}</p>
    <p>{`apiHeroAssetImg doc-service-hero`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://acrobatservices.adobe.com/dc-integration-creation-app-cdn/main.html?api=pdf-services-api"
        }}>{`Start for free`}</a></li>
    </ul>
    {/* Why PDF Services API */}
    <WrapperComponent slots="content" repeat="1" theme="lightest" className="why-pdf-services Why-PDF-Services-API" mdxType="WrapperComponent" />
    <WhyPDFServicesAPI mdxType="WhyPDFServicesAPI" />
    {/* Carousel Block */}
    <AWSMSCarousel mdxType="AWSMSCarousel" />
    {/* Key Features Code Block */}
    <KeyFeaturesCodeBlock mdxType="KeyFeaturesCodeBlock" />
    {/*Adobe PDF Extract API */}
    <WrapperComponent slots="content" repeat="1" theme="lightest" className="AdobePDFExtractAPI" mdxType="WrapperComponent" />
    <AdobePDFExtractAPI mdxType="AdobePDFExtractAPI" />
    {/*Stepper Block */}
    <WrapperComponent slots="content" repeat="1" theme="light" className="start-modifying-pdf" mdxType="WrapperComponent" />
    <StartModifyingPDF mdxType="StartModifyingPDF" />
    {/*Resource Card Block */}
    <WrapperComponent slots="content" repeat="1" theme="lightest" className="Use-cases-for-PDF-services-API" mdxType="WrapperComponent" />
    <UseCasesResourceCard mdxType="UseCasesResourceCard" />
    <TextBlock slots="buttons" isCentered theme="lightest" className='padding-5 Use-cases-for-PDF-services-API' mdxType="TextBlock" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/src/pages/use-cases/agreements-and-contracts/sales-proposals-and-contracts/"
        }}>{`View all use cases`}</a></li>
    </ul>
    <WrapperComponent slots="content" repeat="1" theme="light" className="other-Adobe-Document-Services-APIs" mdxType="WrapperComponent" />
    <DocumentServicesProductCards mdxType="DocumentServicesProductCards" />
    <NewsLetterBlade className="news-letter" mdxType="NewsLetterBlade" />
    <DCSummaryBlock slots="image, heading, text, buttons" theme="lightest" background="white" className="How-to-get-started" mdxType="DCSummaryBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1060px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "31.69811320754717%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/96797533521002ee15b4f820d07b2740/dda86/bg-hero.webp 265w", "/document-services/static/96797533521002ee15b4f820d07b2740/010e6/bg-hero.webp 530w", "/document-services/static/96797533521002ee15b4f820d07b2740/668f0/bg-hero.webp 1060w", "/document-services/static/96797533521002ee15b4f820d07b2740/89d57/bg-hero.webp 1590w", "/document-services/static/96797533521002ee15b4f820d07b2740/4250d/bg-hero.webp 1680w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/96797533521002ee15b4f820d07b2740/35d86/bg-hero.jpg 265w", "/document-services/static/96797533521002ee15b4f820d07b2740/7d9a0/bg-hero.jpg 530w", "/document-services/static/96797533521002ee15b4f820d07b2740/44a6b/bg-hero.jpg 1060w", "/document-services/static/96797533521002ee15b4f820d07b2740/ffe9b/bg-hero.jpg 1590w", "/document-services/static/96797533521002ee15b4f820d07b2740/e1372/bg-hero.jpg 1680w"],
            "sizes": "(max-width: 1060px) 100vw, 1060px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/96797533521002ee15b4f820d07b2740/44a6b/bg-hero.jpg",
            "alt": "We're ready",
            "title": "We're ready",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "were-ready-to-help"
    }}>{`We're ready to help`}</h2>
    <p>{`Have questions about the Acrobat Services APIs?`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://community.adobe.com/t5/document-services-apis/bd-p/Document-Cloud-SDK?page=1&sort=latest_replies&filter=all"
        }}>{`Go to the Adobe Forum`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../pricing/contact.md"
        }}>{`Contact us`}</a></li>
    </ul>
    <APIPixelRetargeting mdxType="APIPixelRetargeting" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      